import React from 'react'

import { ArrowSvg, FilterSvg } from '@svg/react'

import FloorplateSkeleton from './floorplate-skeleton'
import SidePanelSkeleton from './side-panel-skeleton'

interface BuildingSkeletonProps {
  fullscreen: boolean
}

function BuildingSkeleton({ fullscreen }: BuildingSkeletonProps) {
  return (
    <div className="flex h-full w-full">
      {!fullscreen && (
        <div className="h-full w-[350px] flex-grow-0 bg-[#EEEEEE]">
          <div className="flex justify-between bg-white p-4">
            <button
              className="rounded-full border border-zinc-400 p-1"
              type="button"
            >
              <ArrowSvg className="h-6 w-6 stroke-zinc-400" rotate="left" />
            </button>

            <button
              type="button"
              className="relative rounded bg-mainColour px-3 py-1 text-white"
            >
              <div className="inline-flex items-center">
                <span className="text-xs font-bold tracking-widest">
                  Add Filter
                </span>
                <FilterSvg className="ml-1 h-4 w-4" />
              </div>
              <span className="absolute -right-2 -top-2 h-5 w-5 rounded-full border-2 border-mainColour bg-white text-xs font-bold text-mainColour">
                0
              </span>
            </button>
          </div>
          <SidePanelSkeleton />
        </div>
      )}
      <FloorplateSkeleton />
    </div>
  )
}

export default BuildingSkeleton
